import { useContext, useEffect, useState } from 'react';
import { AppContext } from '../../app-context';
import Chart, { ReactGoogleChartEvent } from 'react-google-charts';
import { convertToEndDate, convertToStartDate, formatTo0Decimal } from '../common/util.services';
import { getOrderTrend } from './order.services';
import { FormControl, FormControlLabel, Grid, Radio, RadioGroup } from '@mui/material';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import IButton from '../../components/button/i-button.component';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';
import { DAYS_YEAR } from '../common/constants';

const OrderTrend = () => {
  const appContext = useContext(AppContext);
  const [saleData, setSaleData] = useState([]);
  const [type, setType] = useState('Month');
  const [monthClick, setMonthClick] = useState(false);
  dayjs.extend(utc);
  dayjs.extend(timezone);
  let today = dayjs();
  let sDate = today.subtract(DAYS_YEAR, 'day');
  const [startDate, setStartDate] = useState<any>(sDate);
  const [endDate, setEndDate] = useState<any>(today);
  const [searchData, setSearchData] = useState<any>({startDate: startDate, endDate: endDate, type: type});
  const options = { legend: {position: 'none', alignment: 'center'}, colors: ["purple"], tooltip: { trigger: "none" },
                    vAxis: { viewWindow: { min: 0}}};
  const chartEvents: ReactGoogleChartEvent[] = [
    {
      eventName: "select",
      callback: ({ chartWrapper }) => {
        if(!chartWrapper) return;

        const chart = chartWrapper.getChart();
        const selection = chart.getSelection();
        if (selection.length > 0) {
          const {row} = selection[0];
          const dimension = saleData[row + 1][0];
          if('Month' === type) {
            setType('Customer');
            let sDate = dayjs(convertToStartDate(dimension));
            let eDate = dayjs(convertToEndDate(dimension));
            setStartDate(sDate);
            setEndDate(eDate);
            setMonthClick(true);
            let searchData = {startDate: sDate, endDate: eDate, type: 'Customer'};
            setSearchData(searchData);
          }
        }
      },
    },
  ];
  
  useEffect(() => {
    getData();
  }, [searchData]);

  function getData() {
    getOrderTrend(searchData, appContext,
      (response: any) => {
        let orderData: any = [["Dimension", "Order Value", {role: "annotation"}]];
        for(let i = 0; i < response.data.length; ++i) {
          let data: any = [response.data[i][0], +response.data[i][1], formatTo0Decimal(response.data[i][2])];
          orderData.push(data);
        }
        setSaleData(orderData);
        appContext.setShowLoader(false);
      }, (error: any) => {
        console.log(error);
        appContext.setShowLoader(false);
        appContext.setErrorMessage(error.message);
      });
  };

  const startDatechange = (value: any) => {
    setStartDate(value);
  }

  const endDatechange = (value: any) => {
    setEndDate(value);
  }

  const search = (e: any) => {
    let searchData = {startDate: startDate, endDate: endDate, type: type};
    setSearchData(searchData);
  }

  const reset = (e: any) => {
    setMonthClick(false);
    let today = dayjs();
    let sDate = today.subtract(DAYS_YEAR, 'day');
    setStartDate(sDate);
    setEndDate(today);
    setType('Month');
    let searchData = {startDate: sDate, endDate: today, type: 'Month'};
    setSearchData(searchData);
  }

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setType((event.target as HTMLInputElement).value);
  }

  return <>
  <Grid xs={2} sx={{ pl: 2, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
    <FormControlLabel control={<LocalizationProvider dateAdapter={AdapterDayjs}>
                                  <DatePicker slotProps={{ textField: { size: 'small' } }} format={'DD/MM/YYYY'} disabled={monthClick}
                                    label={'Start Date'} value={startDate} onChange={startDatechange} timezone="Asia/Kolkata"/>
                                </LocalizationProvider>} label='' />
    <FormControlLabel control={<LocalizationProvider dateAdapter={AdapterDayjs}> 
                                  <DatePicker slotProps={{ textField: { size: 'small' } }} format={'DD/MM/YYYY'} disabled={monthClick}
                                    label={'End Date'} value={endDate} onChange={endDatechange} timezone="Asia/Kolkata"/>
                                </LocalizationProvider>} label='' />
    <FormControl>
      <RadioGroup value={type} name="type" row={true} onChange={handleChange}>
        <FormControlLabel value="Month" control={<Radio />} label="Month" disabled={monthClick} />
        <FormControlLabel value="Customer" control={<Radio />} label="Customer" disabled={monthClick}/>
      </RadioGroup>
    </FormControl>
    <IButton label='Submit' onActionEvent={search}/>
    <IButton label='Reset' onActionEvent={reset} color='secondary'/>
  </Grid>
  <Chart chartType="ColumnChart" height={"500px"} width="1200px" data={saleData} options={options} chartEvents={chartEvents}/>
  </>
}

export default OrderTrend;

